import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('deliveryNote', 'deliveryNotes');

const customActions = {
  async LOAD_deliveryNotes({ rootGetters, commit }) {
    const data = await odata.o(rootGetters)
      .get('deliveryNotes')
      .query({
        $filter: 'isDeleted eq false',
        $expand: 'Farm',
        $orderby: 'ReceivingDate desc',
      });
    commit('SET_deliveryNotes', data);
    return data;
  },
};

export default { ...actions, ...customActions };
